var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSacolaSair(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 17,
    viewBox: "0 0 15 17",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.8909 7.66667V3.5C4.89099 2.83696 5.15438 2.20107 5.62322 1.73223C6.09206 1.26339 6.72795 1 7.39099 1C8.05403 1 8.68992 1.26339 9.15876 1.73223C9.6276 2.20107 9.89099 2.83696 9.89099 3.5V7.66667M2.66687 5.16667H12.116C12.3563 5.16664 12.5938 5.21857 12.8122 5.31892C13.0305 5.41926 13.2246 5.56563 13.3811 5.748C13.5376 5.93037 13.6528 6.14443 13.7188 6.37549C13.7848 6.60655 13.8001 6.84915 13.7635 7.08667L12.7177 13.88C12.6269 14.4704 12.3277 15.0087 11.8744 15.3976C11.421 15.7865 10.8433 16.0002 10.246 16H4.53603C3.93887 16 3.36143 15.7862 2.90822 15.3973C2.45501 15.0085 2.15597 14.4702 2.0652 13.88L1.01937 7.08667C0.982839 6.84915 0.998107 6.60655 1.06412 6.37549C1.13013 6.14443 1.24533 5.93037 1.40182 5.748C1.55831 5.56563 1.75238 5.41926 1.97073 5.31892C2.18909 5.21857 2.42656 5.16664 2.66687 5.16667Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 9L6 12M6 9L8 12",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSacolaSair);
export default __webpack_public_path__ + "static/media/sacolaSair.2c097b12aa5732ba109e0f2d4ec455f6.svg";
export { ForwardRef as ReactComponent };